import { editMenu, addMenu, menuList } from './request';
export default {
  data() {
    return {
      dialogVisible: false,
      type: '',
      roleFrom: {
        name: '',
        position: '',
        mark: '',
        sort: 0,
        remark: ''
      },
      treeData: []
    };
  },
  computed: {
    roleRule() {
      return {
        name: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('名称')
        }],
        mark: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('权限标识')
        }],
        position: [{
          required: true,
          message: this.$t('请选择') + this.$t('类型'),
          trigger: 'change'
        }],
        isOpen: [{
          required: true,
          message: this.$t('请选择') + this.$t('状态'),
          trigger: 'change'
        }],
        isShow: [{
          required: true,
          message: this.$t('请选择') + this.$t('客户是否可见'),
          trigger: 'change'
        }]
      };
    }
  },
  methods: {
    init(val, type) {
      console.log(type, val);
      if (type == 'add') {
        this.roleFrom.parentId = val.id;
        this.roleFrom.parentName = val.name;
        this.roleFrom.isOpen = val.isOpen;
      } else {
        this.roleFrom = val;
        this.roleFrom.menuId = val.id;
        menuList({
          isOpen: val.isOpen,
          position: val.position == 3 ? 2 : 1
        }).then(res => {
          this.treeData = res;
        });
      }
      this.dialogVisible = true;
      this.type = type;
    },
    handleSure() {
      this.$refs.roleFrom.validate(valid => {
        this.loading = true;
        if (valid) {
          if (this.roleFrom.id) {
            //编辑
            editMenu(this.roleFrom).then(() => {
              this.$message.success(this.$t('修改成功'));
              this.loading = false;
              this.$emit('ok');
              this.$emit('cancel');
            });
          } else {
            //新增
            addMenu(this.roleFrom).then(() => {
              this.$message.success(this.$t('添加成功'));
              this.loading = false;
              this.$emit('ok');
              this.$emit('cancel');
            });
          }
        } else {
          this.loading = false;
        }
      });
    }
  }
};